<template>
  <div>
    <b-card>
      <b-card-title> Nota Promissora </b-card-title>
      <b-card-text>
        <b-row>
          <b-col> Documento: {{ bill.document }} </b-col>
          <b-col class="text-right">
            Vencimento {{ bill.due_date | dateBr }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            No dia {{ bill.due_date | dateBr }} pagarei(emos) por
            esta única via de NOTA PROMISSÓRIA a
            <b
              >{{ bill.company.name }} (CNPJ
              {{ bill.company.cnpj | cnpj }})</b
            >
            ou à sua ordem, a quantia de
            {{
              (bill.value - bill.received_value) | moneyBr
            }}
            ({{
              (bill.value - bill.received_value)
                | decimal
                | extenso
            }}).
          </b-col>
        </b-row>
        <b-row class="py-4"
          ><b-col
            >Praça de pagamento:
            <b
              >{{ bill.company.address.city }}/{{
                bill.company.address.state
              }}</b
            >
          </b-col></b-row
        >

        <b-row>
          <b-col cols="12">
            Emitente:
            <b>{{ bill.person.name }}</b>
          </b-col>
          <b-col class="text-left">
            Emitido em: {{ bill.company.address.city }},
            {{ bill.created_at | dateBr }}
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <span v-if="!isJuridic">CPF {{ person_document | cpf }} </span>
            <span v-if="isJuridic"> CNPJ{{ person_document | cnpj }} </span>
          </b-col>
          <b-col
            v-for="addressPerson in bill.addressPerson"
            :key="addressPerson.index"
          >
            {{ addressPerson.address }}, {{ addressPerson.number }}
            {{ addressPerson.complement }} - {{ addressPerson.district }} <br />
            {{ addressPerson.city }} - {{ addressPerson.state }} - CEP:
            {{ addressPerson.zipcode }}
          </b-col>
        </b-row>
        <b-row class="d-flex justify-content-center text-center mt-5">
          <b-col>
            <hr />
            Assinatura do Emitente
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    bill: {
      type: Object,
    },
  },

  computed: {
    isJuridic() {
      return this.bill.person.person_type == "j";
    },

    person_document() {
      if (this.isJuridic) {
        return this.bill.person.cnpj ? this.bill.person.cnpj : "";
      }
      if (!this.isJuridic) {
        return this.bill.person.cpf ? this.bill.person.cpf : "";
      }
    },
  },
};
</script>

<style scoped>
.card {
  width: 80mm;
  font-family: "Arial", sans-serif;
}
.card-title {
  text-align: center;
}

hr {
  border: 2px #000000 solid;
}
@media print {
  .card {
    width: 40%;
    height: 100%;
    border: none;
    font-weight: 900;
    text-align: justify;
    font-family: "Arial", sans-serif;
  }
  .card-title {
    font-weight: 900;
  }
}
</style>